import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPlayerFavorites = () => {
    const send = useGenericSend();

    return useCallback(async ({ requestedFavorites = ['games'] } = {}) => {
        const {
            data: { favoriteGames = [] }
        } = await send<Types.IGetPlayerFavoritesRequestData, Types.IGetPlayerFavoritesResponseData>({
            ID: 31103,
            errorLevel: 1,
            requestedFavorites,
            description: 'Get Favorite Games',
            responses: [31104, 31105]
        });

        return { favoriteGames };
    }, [send]);
};
